class SuppliersService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/suppliers', params);
  }

  create(params) {
    return this.apiService.post('/api/v1/avg/suppliers', params);
  }

  update(params) {
    return this.apiService.put(`/api/v1/avg/suppliers/${params.id}`, params);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/avg/suppliers', params);
  }
}

export default SuppliersService;
